// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1SLVG","col":"styles_col__2lXTp"};